import { FormHandler } from './FormHandler';
export { FormHandler };
export const initFormHandler = () => {
    if (!window.formHandler) {
        window.formHandler = new FormHandler();
    }
};
